"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var useAmount_1 = require("./useAmount");
var usePlayGame_1 = require("./usePlayGame");
var WinOfTheMonth = function (_a) {
    var currentGame = _a.currentGame, winData = _a.winData;
    var t = (0, next_intl_1.useTranslations)('translation');
    var amount = (0, useAmount_1.useAmount)(winData);
    var playGameHandler = (0, usePlayGame_1.usePlayGame)(currentGame);
    if (!(winData === null || winData === void 0 ? void 0 : winData.win) || !(currentGame === null || currentGame === void 0 ? void 0 : currentGame.id) || !(currentGame === null || currentGame === void 0 ? void 0 : currentGame.title))
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.titleContainer },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                react_1.default.createElement("span", null, t('winOfTheMonth')))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.amount }, amount),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inGameContainer },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.in }, t('in')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.game, onClick: playGameHandler }, currentGame === null || currentGame === void 0 ? void 0 : currentGame.title)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonContainer },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: playGameHandler }, t('play')))));
};
exports.default = WinOfTheMonth;
